/* ==========================================================================
   Dynoforce header
   USP-balk inklappen, meereizende balk op een telefoon, mobiel menu,
   winkelwagenteller en de auto-finder.
   Voertuigdata komt uit window.DFData, zie df-data.js.
   ========================================================================== */

(function () {
  'use strict';

  var hdr = document.querySelector('.hdr');
  if (!hdr) return;

  /* ---------- Skiplink 'Naar de inhoud' ---------------------------------
     De focus gaat hier zelf naar #MainContent (tabindex -1), zonder het
     #-adres in de adresbalk te zetten (audit TECH-D, 11-10-2026). Twee
     redenen. global.js vangt elke klik op een #-link af om zacht te scrollen
     en verplaatst de focus niet (daarom heeft de link ook no-scroll). En op
     pagina's met een filterbalk (zoeken, collecties) reageert df-shopajax.js
     op elke popstate door de pagina opnieuw op te halen; met een #-adres
     erbij ging dat telkens mis en volgde er weer een sprong naar
     #MainContent, zodat de volgende Tab steeds terugviel op de inhoud.
     Zonder JavaScript werkt de link gewoon als ankerlink.                  */
  var skip = document.querySelector('.df-skip');
  var hoofd = document.getElementById('MainContent');
  if (skip && hoofd) {
    skip.addEventListener('click', function (e) {
      e.preventDefault();
      if (!hoofd.hasAttribute('tabindex')) hoofd.setAttribute('tabindex', '-1');
      hoofd.focus({ preventScroll: true });
      window.scrollTo(0, Math.max(0, Math.round(hoofd.getBoundingClientRect().top + window.scrollY)));
    });
  }

  /* ---------- USP-balk klapt in zodra je scrollt -------------------------
     Dit bestand laadt met defer en draait dus pas nadat de pagina al een keer
     getekend is. De balk staat op dat moment open, want de markup kent geen
     statusklasse. Zet je daarna 'scrolled' terwijl de transitie aanstaat, dan
     schuift hij zichtbaar dicht terwijl de bezoeker niets gedaan heeft.

     Bij het heropenen van een tabblad is dat het ergst: de browser zet een
     herstelde scrollpositie pas rond het load-event terug, dus op het moment
     dat dit script draait is scrollY nog nul en klopt de eerste meting niet.
     Vandaar twee dingen: opnieuw meten op de momenten waarop de browser die
     positie kan terugzetten, en de animatie pas aanzetten bij het eerste echte
     gebaar. Tot dat moment landt de balk in een keer in de goede stand.      */
  function onScroll() {
    hdr.classList.toggle('scrolled', window.scrollY > 40);
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  addEventListener('load', onScroll);
  addEventListener('pageshow', onScroll);

  function animatieAan() { hdr.classList.add('hdr--anim'); }
  ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (t) {
    addEventListener(t, animatieAan, { once: true, passive: true });
  });

  /* ---------- Meereizende balk op een telefoon ----------------------------
     De kop staat absolute bovenaan en scrolt gewoon weg (zie df-header.css).
     Op een telefoon is een pagina al gauw acht tot twaalf schermen hoog, en
     na het eerste scherm was er dan nergens meer een menu, zoekknop of
     winkelmandje. Daarom krijgt dezelfde .hdr de klasse hdr--mee zodra de
     bezoeker voorbij de onderkant van de navbalk is; df-header.css maakt hem
     dan onder 980px vast en compact. Hij komt in beeld bij omhoog scrollen
     (hdr--zicht) en schuift weg bij omlaag scrollen. Op desktop doet de
     klasse niets, dat regelt de CSS.

     Twee drempels. Erin voorbij de onderkant van de navbalk: de kop is dan
     al uit beeld, dus daar zie je niets van. Eruit pas zodra de onderste
     56px van de gewone kop weer in beeld zouden staan, precies waar de
     compacte balk stond; zo neemt de gewone balk het op dezelfde plek over
     en springt er niets.

     Meten gebeurt alleen in de gewone stand, want in de vaste stand is de
     kop lager. Een gebaar telt pas vanaf zes pixels, anders wipt de balk
     bij elk trillinkje van een vinger. Buiten de pagina (het veren van iOS
     boven- en onderaan) telt niet mee. Staat er een paneel open, dan blijft
     de balk ook na het sluiten staan tot het volgende gebaar omlaag.       */
  var nav = hdr.querySelector('nav.df-nav');
  var BALK_H = 56;
  var kopH = 0;
  var vorigeY = 0;
  /* Staat op true zolang het mobiele menu de pagina vasthoudt, zie "Mobiel
     menu" verderop. De vergrendeling zet body vast en daarmee scrollY op
     nul; zou deze meting dan doorgaan, dan zag hij "terug bovenaan" en
     haalde hij de vaste balk weg terwijl het menu eraan hangt. */
  var menuVast = false;

  function paneelOpen() {
    return hdr.classList.contains('open') || hdr.classList.contains('zoekopen') || hdr.classList.contains('fopen');
  }

  function meereis() {
    if (!nav || menuVast) return;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var y = Math.min(Math.max(window.scrollY, 0), Math.max(max, 0));
    var mee = hdr.classList.contains('hdr--mee');
    if (!mee) {
      kopH = nav.offsetTop + nav.offsetHeight;
      if (y > kopH) {
        /* Zonder overgang erin, anders schuift de balk zichtbaar weg op het
           moment dat hij vast wordt. Een reflow afdwingen zet de stand vast
           voordat de overgang weer aan mag. */
        hdr.classList.add('hdr--mee', 'hdr--stil');
        hdr.classList.toggle('hdr--zicht', paneelOpen());
        void hdr.offsetWidth;
        hdr.classList.remove('hdr--stil');
        mee = true;
        vorigeY = y;
      }
    } else if (y <= kopH - BALK_H) {
      hdr.classList.remove('hdr--mee', 'hdr--zicht');
      mee = false;
    }
    if (mee) {
      var d = y - vorigeY;
      if (d <= -6) {
        hdr.classList.add('hdr--zicht');
        vorigeY = y;
      } else if (d >= 6) {
        if (!paneelOpen()) hdr.classList.remove('hdr--zicht');
        vorigeY = y;
      }
    } else {
      vorigeY = y;
    }
  }
  addEventListener('scroll', meereis, { passive: true });
  addEventListener('resize', meereis);
  addEventListener('load', meereis);
  addEventListener('pageshow', meereis);
  meereis();

  /* ---------- Dichte navbalk op pagina's zonder donkere kop ---------------
     De doorzichtige balk is gemaakt voor pagina's die met een donkere hero
     beginnen. Op de winkelwagen, zoekresultaten of een 404 staat hij op een
     lichte achtergrond en wordt hij grauw. Daar krijgt hij een dichte kleur. */
  function bepaalNavKleur() {
    /* Zoekresultaten, winkelwagen en 404 krijgen de dichte kleur al in de
       markup (data-nav-vast, zie df-header.liquid). Op /search is het eerste
       gevulde vlak de donkere autostrook, dus de meting hieronder hield de
       balk daar juist doorzichtig (audit NAV-E, 11-10-2026). Niet meten dus,
       anders haalt een latere meting de klasse weer weg. */
    if (hdr.hasAttribute('data-nav-vast')) {
      hdr.classList.add('hdr--vast');
      return;
    }
    var main = document.querySelector('main') || document.body;
    var sec = main.querySelector('.shopify-section');
    var kandidaten = [];
    if (sec) {
      kandidaten.push(sec);
      /* De sectie begint met een style-blok, dus zoek het eerste echte vlak
         met hoogte. Coordinaten gebruiken kan niet: in een verborgen venster
         is innerWidth nul en levert elementsFromPoint niets op. */
      var alle = sec.querySelectorAll('*');
      for (var n = 0; n < alle.length && kandidaten.length < 14; n++) {
        var tag = alle[n].tagName;
        if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'LINK' || tag === 'TEMPLATE' || tag === 'NOSCRIPT') continue;
        if (alle[n].getBoundingClientRect().height < 80) continue;
        kandidaten.push(alle[n]);
      }
    }
    kandidaten.push(document.body);
    for (var i = 0; i < kandidaten.length; i++) {
      var bg = getComputedStyle(kandidaten[i]).backgroundColor;
      if (!bg || bg === 'transparent' || bg.replace(/\s/g, '') === 'rgba(0,0,0,0)') continue;
      var d = bg.match(/\d+(\.\d+)?/g);
      if (!d || d.length < 3) continue;
      var helderheid = 0.299 * +d[0] + 0.587 * +d[1] + 0.114 * +d[2];
      hdr.classList.toggle('hdr--vast', helderheid > 140);
      return;
    }
  }
  /* Meerdere meetmomenten: vlak na het laden staat de opmaak nog niet vast. */
  [0, 200, 600, 1200].forEach(function (ms) { setTimeout(bepaalNavKleur, ms); });
  addEventListener('load', bepaalNavKleur);
  document.addEventListener('shopify:section:load', bepaalNavKleur);

  /* ---------- Roterende boodschappen in de rode balk ----------------------
     Elke zes seconden de volgende boodschap, zoals de oude
     aankondigingsbalk. Bij reduced motion blijft de eerste staan.          */
  var msgWrap = hdr.querySelector('[data-df-top-msgs]');
  if (msgWrap) {
    var msgs = msgWrap.querySelectorAll('.df-top__msg');
    if (msgs.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var actief = 0;
      setInterval(function () {
        msgs[actief].classList.remove('on');
        actief = (actief + 1) % msgs.length;
        msgs[actief].classList.add('on');
      }, 6000);
    }
  }

  /* ---------- Zoeken -----------------------------------------------------
     Klapt open onder de navbalk en zet de aandacht meteen in het veld. Sluit
     het mobiele menu en de finder, want die delen dezelfde ruimte.          */
  var zoekTog = hdr.querySelector('.df-zoek__tog');
  var zoekPaneel = hdr.querySelector('.df-zoek');
  if (zoekTog && zoekPaneel) {
    zoekTog.addEventListener('click', function () {
      var open = hdr.classList.toggle('zoekopen');
      zoekTog.setAttribute('aria-expanded', String(open));
      if (open) {
        hdr.classList.remove('open', 'fopen');
        var veld = zoekPaneel.querySelector('input[name="q"]');
        if (veld) veld.focus();
      } else {
        var bak = zoekPaneel.querySelector('[data-df-zoek-uit]');
        if (bak) bak.hidden = true;
      }
    });
  }

  /* ---------- Live zoekresultaten ----------------------------------------
     Suggesties uit Shopify's eigen voorspellende zoekopdracht. We bouwen de
     rijen met losse knopen en nooit met innerHTML: titels en prijzen komen uit
     de winkel en horen geen opmaak mee te kunnen brengen.                   */
  /* Sinds 1-10-2026 niet alleen in de menubalk: elk blok met data-df-zoekvorm
     (een veld name="q" plus een [data-df-zoek-uit]) krijgt dezelfde live
     suggesties, zoals het zoekveld in de shopkop. */
  /* Engels op /en/, zoals df-zoekauto.js dat ook afleest. */
  var EN = String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN ? {
    niks: 'Nothing found. Try a brand, a part or your licence plate.',
    alle: 'All results for '
  } : {
    niks: 'Niets gevonden. Probeer een merk, een onderdeel of je kenteken.',
    alle: 'Alle resultaten voor '
  };

  /* Pasregel onder een suggestie. De suggestie-API kent geen metavelden,
     maar de tags van een product dragen merk, chassiscodes en bouwjaren
     ("BMW", "F82", "2014" tot "2020"). Welke tags een chassiscode zijn,
     weet de autolijst van de autokiezer ([data-dfa-autos]). Elk label
     daarin bestaat uit de modelnamen van zijn groep plus de code: "A4 / S4
     / RS4 B8 (2008-2015)" in groep "A4 / S4 / RS4", "F82 / F83 M4
     (2014-2020)" in groep "4 serie / M4", "A35 / A45 (W177)" in groep "A35
     / A45". Wat op een code lijkt en niet in de groepsnaam staat, is er
     een: B8, F82, F83, W177. Zo valt "M4" af, maar ook "A4" en "A35", die
     eerst als code golden omdat het label ermee begon (reviewer,
     10-10-2026). Het wordt "BMW F82 \u00B7 2014\u20132020"; zonder codes en jaren
     blijft het leeg en toont de rij alleen de prijs. Eerst stond hier de
     leverancier, en die is bij eigen carbon altijd "Dynoforce \u00AE": dan
     lijken alle rijen op elkaar (audit VIND-5, 10-10-2026). De lijst wordt
     pas gelezen bij de eerste suggestie.                                   */
  var autoLijst = null;
  function lijktCode(d) {
    return /^[A-Za-z]{1,2}\d{1,3}(\.\d)?$/.test(d) || /^\d(\.\d)?[A-Za-z]$/.test(d) || /^(MK|Mk)\d/.test(d);
  }
  function codesLijst() {
    if (autoLijst) return autoLijst;
    autoLijst = { merken: [], codes: [] };
    var bron = document.querySelector('[data-dfa-autos]');
    var rijen = [];
    if (bron) { try { rijen = JSON.parse(bron.textContent) || []; } catch (e) { rijen = []; } }
    rijen.forEach(function (r) {
      if (r.m && autoLijst.merken.indexOf(r.m) < 0) autoLijst.merken.push(r.m);
      var groep = String(r.g || '').toUpperCase().split(/[\s\/]+/);
      /* Haakjes weg, want bij Mercedes staat de code erin: "(W177)". Een
         bouwjaarbereik "(2008-2015)" lijkt op geen enkele code. */
      String(r.l || '').replace(/[()]/g, ' ').split(/\s+/).forEach(function (deel) {
        var d = deel.replace(/[^A-Za-z0-9.]/g, '');
        if (!d || !lijktCode(d)) return;
        d = d.toUpperCase();
        /* Modelnamen die op een code lijken: de groep ("A4 / S4 / RS4") en
           de elektrische i-modellen (i4, iX3). */
        if (groep.indexOf(d) >= 0 || /^IX?\d/.test(d)) return;
        if (autoLijst.codes.indexOf(d) < 0) autoLijst.codes.push(d);
      });
    });
    return autoLijst;
  }
  /* Meer codes dan dit is geen pasvorm meer maar een halve catalogus: de
     Target Blu Eye GO draagt 28 BMW-codes en past in elke auto. Dan
     vervalt de regel en blijft alleen de prijs (reviewer, 10-10-2026). */
  var MAX_CODES = 4;
  function pasregel(item) {
    var tags = item && item.tags;
    if (!tags || !tags.length) return '';
    var lijst = codesLijst();
    var merk = '';
    var codes = [];
    var jaren = [];
    tags.forEach(function (t) {
      var s = String(t).trim();
      if (/^(19|20)\d{2}$/.test(s)) { jaren.push(+s); return; }
      if (!merk && lijst.merken.indexOf(s) >= 0) { merk = s; return; }
      var c = s.toUpperCase();
      if (lijst.codes.indexOf(c) >= 0 && codes.indexOf(c) < 0) codes.push(c);
    });
    if (codes.length > MAX_CODES) codes = [];
    if (!codes.length && !jaren.length) return '';
    var delen = [];
    if (codes.length) delen.push((merk + ' ' + codes.join(' / ')).trim());
    if (jaren.length) {
      var van = Math.min.apply(null, jaren);
      var tot = Math.max.apply(null, jaren);
      delen.push(van === tot ? String(van) : van + '\u2013' + tot);
    }
    return delen.join(' \u00B7 ');
  }

  function bindZoek(zoekVeld, zoekUit, opPagina) {
    var wachten = null;
    var laatsteVraag = '';
    var basis = (window.routes && window.routes.predictive_search_url) || '/search/suggest';

    function leeg() { while (zoekUit.firstChild) zoekUit.removeChild(zoekUit.firstChild); }

    /* De suggestie-API geeft de prijs als kaal getal terug, bijvoorbeeld
       "1316.00". Hier maken we er een bedrag in de huisstijl van: punt als
       duizendtal, hele euro's als "\u20AC349,-" (op /en/ "\u20AC349"), anders met
       komma en centen. */
    function bedrag(ruw) {
      var n = parseFloat(String(ruw).replace(',', '.'));
      if (isNaN(n)) return String(ruw);
      var heel = Math.floor(n);
      var cent = Math.round((n - heel) * 100);
      if (cent === 100) { heel += 1; cent = 0; }
      var m = String(heel).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (!cent) return '\u20AC' + m + (EN ? '' : ',-');
      return '\u20AC' + m + ',' + (cent < 10 ? '0' + cent : cent);
    }

    function regel(item) {
      var a = document.createElement('a');
      a.className = 'df-zoek__rij';
      a.href = item.url;
      a.setAttribute('role', 'option');
      if (item.featured_image && item.featured_image.url) {
        var img = document.createElement('img');
        img.className = 'df-zoek__mini';
        img.src = item.featured_image.url;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 44; img.height = 44;
        a.appendChild(img);
      }
      var tx = document.createElement('div');
      tx.className = 'df-zoek__tx';
      var b = document.createElement('b');
      b.textContent = item.title;
      tx.appendChild(b);
      /* Tweede regel: de pasregel, en op een telefoon ook de prijs (de
         prijskolom rechts gaat daar uit, zie df-header.css). Twee losse
         knopen in een flexrij: de pasregel mag afkappen, de prijs nooit.
         Eerst stond de prijs achteraan in dezelfde nowrap-tekst en viel hij
         bij een lange pasregel buiten beeld (reviewer, 10-10-2026). Het
         scheidingsteken komt uit de CSS. */
      var pas = pasregel(item);
      if (pas || item.price) {
        var sp = document.createElement('span');
        sp.className = 'df-zoek__sub';
        if (pas) {
          var pasEl = document.createElement('em');
          pasEl.className = 'df-zoek__pas';
          pasEl.textContent = pas;
          sp.appendChild(pasEl);
        }
        if (item.price) {
          var sub = document.createElement('i');
          sub.className = 'df-zoek__sub-prijs';
          sub.textContent = bedrag(item.price);
          sp.appendChild(sub);
        }
        tx.appendChild(sp);
      }
      a.appendChild(tx);
      if (item.price) {
        var pr = document.createElement('div');
        pr.className = 'df-zoek__prijs';
        pr.textContent = bedrag(item.price);
        a.appendChild(pr);
      }
      return a;
    }

    function toon(data, q) {
      leeg();
      var bron = (data && data.resources && data.resources.results) || {};
      var producten = bron.products || [];
      var paginas = (bron.pages || []).concat(bron.articles || []);

      /* Eerst de auto, als de zoekterm er een bevat (df-zoekauto.js). Daarna
         pas de producten van Shopify; zonder auto blijft alles zoals het was. */
      var autoBlok = window.DFZoekAuto ? window.DFZoekAuto.blok(q) : null;
      if (autoBlok) zoekUit.appendChild(autoBlok);

      if (!producten.length && !paginas.length) {
        if (!autoBlok) {
          var niks = document.createElement('div');
          niks.className = 'df-zoek__niks';
          niks.textContent = T.niks;
          zoekUit.appendChild(niks);
        }
        zoekUit.hidden = false;
        return;
      }
      if (autoBlok) zoekUit.appendChild(window.DFZoekAuto.tussenkop());
      producten.slice(0, 6).forEach(function (p) { zoekUit.appendChild(regel(p)); });
      paginas.slice(0, 3).forEach(function (p) { zoekUit.appendChild(regel(p)); });

      var meer = document.createElement('a');
      meer.className = 'df-zoek__meer';
      meer.href = ((window.routes && window.routes.search_url) || '/search') + '?q=' + encodeURIComponent(q);
      meer.textContent = T.alle + '"' + q + '"';
      zoekUit.appendChild(meer);
      zoekUit.hidden = false;
    }

    zoekVeld.addEventListener('input', function () {
      var q = zoekVeld.value.trim();
      clearTimeout(wachten);
      if (q.length < 2) { leeg(); zoekUit.hidden = true; return; }
      /* De auto meteen tonen; die lijst staat al op de pagina, daar hoeft
         niets voor opgehaald te worden. */
      if (window.DFZoekAuto) window.DFZoekAuto.ververs(zoekUit, q);
      /* Even wachten met typen, anders vuren we bij elke aanslag een verzoek af. */
      wachten = setTimeout(function () {
        if (q === laatsteVraag) return;
        laatsteVraag = q;
        fetch(basis + '.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product,page,article&resources[limit]=6' +
              '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku', {
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { if (d && zoekVeld.value.trim() === q) toon(d, q); })
          .catch(function () { /* stil: het formulier werkt nog gewoon */ });
      }, 220);
    });

    /* Op een pagina is er geen paneel dat dichtklapt, dus daar sluit het
       menu bij Escape, bij een klik ernaast, en komt het terug zodra het
       veld weer de aandacht krijgt. */
    if (opPagina) {
      var wrap = zoekUit.parentNode;
      var terug = function () {
        if (zoekVeld.value.trim().length >= 2 && zoekUit.firstChild) zoekUit.hidden = false;
      };
      zoekVeld.addEventListener('focus', terug);
      zoekVeld.addEventListener('click', terug);
      zoekVeld.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') zoekUit.hidden = true;
      });
      document.addEventListener('click', function (e) {
        if (wrap && !wrap.contains(e.target)) zoekUit.hidden = true;
      });
    }
  }

  var zoekUit = hdr.querySelector('[data-df-zoek-uit]');
  var zoekVeld = hdr.querySelector('.df-zoek__veld');
  if (zoekUit && zoekVeld) bindZoek(zoekVeld, zoekUit, false);
  Array.prototype.forEach.call(document.querySelectorAll('[data-df-zoekvorm]'), function (wrap) {
    var veld = wrap.querySelector('input[name="q"]');
    var uit = wrap.querySelector('[data-df-zoek-uit]');
    if (veld && uit && !hdr.contains(wrap)) bindZoek(veld, uit, true);
  });

  /* ---------- Mobiel menu ------------------------------------------------
     Sinds 10-10-2026 (audit NAV-C) vult het menu het scherm onder de balk
     en staat de pagina erachter stil. Twee dingen regelt dit script
     daarvoor. De bovenkant van het menu: --df-menu-top is de onderkant van
     de navbalk, die bovenaan de pagina op 101px ligt en in de meereizende
     stand op 57px. En de vergrendeling: body gaat vast op de huidige
     scrollstand (html.df-menu-open, zie df-header.css), want alleen
     overflow:hidden laat iOS Safari gewoon doorscrollen; bij het sluiten
     komt de stand terug.

     De klasse 'open' wordt niet alleen hier weggehaald: df-auto.js doet dat
     als de autokiezer opent, en Escape hieronder ook. Daarom kijkt een
     MutationObserver naar de klasse en houdt hij vergrendeling en
     aria-expanded gelijk met wat er werkelijk staat, wie het ook zet.      */
  var mnu = hdr.querySelector('.mnu');
  var menuScrollY = 0;
  var root = document.documentElement;

  function menuTop() {
    if (!nav) return;
    hdr.style.setProperty('--df-menu-top', Math.max(0, Math.round(nav.getBoundingClientRect().bottom)) + 'px');
  }
  function vergrendel() {
    if (menuVast) return;
    menuScrollY = window.scrollY;
    menuTop();
    /* Eerst de vlag, dan pas de klasse: het vastzetten van body zet scrollY
       op nul en dat scroll-event mag de meereizende balk niet bereiken. */
    menuVast = true;
    document.body.style.top = -menuScrollY + 'px';
    root.classList.add('df-menu-open');
  }
  function ontgrendel() {
    if (!menuVast) return;
    root.classList.remove('df-menu-open');
    document.body.style.top = '';
    hdr.style.removeProperty('--df-menu-top');
    menuVast = false;
    window.scrollTo(0, menuScrollY);
  }
  function menuSync() {
    var open = hdr.classList.contains('open');
    if (mnu) mnu.setAttribute('aria-expanded', String(open));
    if (open) vergrendel(); else ontgrendel();
  }

  if (mnu) {
    mnu.addEventListener('click', function () {
      var open = hdr.classList.toggle('open');
      if (open) {
        hdr.classList.remove('fopen', 'zoekopen');
        if (zoekTog) zoekTog.setAttribute('aria-expanded', 'false');
      }
      menuSync();
    });
    hdr.querySelectorAll('.lnk a:not(.ftog)').forEach(function (a) {
      a.addEventListener('click', function () {
        hdr.classList.remove('open');
        menuSync();
      });
    });
    if ('MutationObserver' in window) {
      new MutationObserver(menuSync).observe(hdr, { attributes: true, attributeFilter: ['class'] });
    }
    /* Draait het scherm, dan ligt de onderkant van de balk ergens anders. */
    addEventListener('resize', function () { if (menuVast) menuTop(); });
  }

  /* Escape sluit menu, zoekpaneel en finder. Stond het menu open, dan gaat
     de aandacht terug naar de hamburger, zodat je met het toetsenbord niet
     in het niets belandt. */
  addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var menuWasOpen = hdr.classList.contains('open');
    hdr.classList.remove('open', 'fopen', 'zoekopen');
    menuSync();
    if (mnu && menuWasOpen) { try { mnu.focus(); } catch (er) { /* niet focusbaar, dan niet */ } }
    if (zoekTog) zoekTog.setAttribute('aria-expanded', 'false');
    var t = hdr.querySelector('.ftog');
    if (t) t.setAttribute('aria-expanded', 'false');
  });

  /* ---------- Winkelwagenteller -----------------------------------------
     Dawn stuurt na elke wijziging een cart-update via pubsub. We lezen het
     aantal daaruit en vallen terug op /cart.js als het veld ontbreekt.    */
  var counters = document.querySelectorAll('[data-df-cart-count]');

  function setCount(n) {
    counters.forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
      var link = el.closest('.df-cart');
      if (link) {
        link.setAttribute('aria-label', n === 0
          ? 'Winkelmand, leeg'
          : 'Winkelmand, ' + n + (n === 1 ? ' artikel' : ' artikelen'));
      }
    });
  }

  function refreshFromApi() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () { /* teller blijft staan zoals hij stond */ });
  }

  if (counters.length && typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = event && event.cartData && event.cartData.item_count;
      if (typeof count === 'number') setCount(count);
      else refreshFromApi();
    });
  }

  /* Dawn en Ignite verversen na elke cart-wijziging de sectie
     cart-icon-bubble in #cart-icon-bubble; dat is bij ons een verborgen span
     in het winkelwagen-anker. Meekijken op die swap werkt in beide thema's,
     ook als hun pubsub niet als globale functie bestaat.                    */
  var bubbleSink = document.getElementById('cart-icon-bubble');
  if (counters.length && bubbleSink && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var b = bubbleSink.querySelector('.cart-count-bubble span[aria-hidden]');
      var n = b ? parseInt(b.textContent, 10) : NaN;
      if (!isNaN(n)) setCount(n);
      else refreshFromApi();
    }).observe(bubbleSink, { childList: true, subtree: true });
  }

  /* Naar buiten, zodat andere secties de teller kunnen bijwerken zonder hun
     eigen halve versie te schrijven. setCount regelt ook het hidden-attribuut
     en het aria-label - juist dat ging elders mis.

     Dit is niet voor de sier. De pubsub-abonnee hierboven vuurt namelijk
     nooit: assets/constants.js declareert PUB_SUB_EVENTS als top-level const
     in een classic script, en zo'n const komt niet op window terecht. De
     voorwaarde is dus altijd onwaar. Deze haak is de werkende vervanging. */
  window.DFCart = {
    setCount: setCount,
    ververs: refreshFromApi
  };

  /* ---------- Auto-finder ------------------------------------------------ */
  var ftog = hdr.querySelector('.ftog');
  var panel = hdr.querySelector('.finder');
  if (!ftog || !panel) return;

  var sMerk = panel.querySelector('[data-f="merk"]');
  var sModel = panel.querySelector('[data-f="model"]');
  var sGen = panel.querySelector('[data-f="gen"]');
  var sMot = panel.querySelector('[data-f="mot"]');
  var go = panel.querySelector('[data-f="go"]');
  var msg = panel.querySelector('.fmsg');
  var tree = null;

  function placeholder(sel, label) {
    sel.innerHTML = '<option value="">' + label + '</option>';
    sel.disabled = true;
  }
  function fill(sel, items, label) {
    sel.innerHTML = '<option value="">' + label + '</option>' +
      items.map(function (i) {
        return '<option value="' + escapeAttr(i) + '">' + escapeHtml(i) + '</option>';
      }).join('');
    sel.disabled = false;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function resetFrom(level) {
    if (level <= 2) placeholder(sModel, sModel.dataset.label);
    if (level <= 3) placeholder(sGen, sGen.dataset.label);
    if (level <= 4) placeholder(sMot, sMot.dataset.label);
    go.disabled = true;
  }

  ftog.addEventListener('click', function (e) {
    e.preventDefault();
    var open = hdr.classList.toggle('fopen');
    ftog.setAttribute('aria-expanded', String(open));
    if (open) {
      hdr.classList.remove('open');
      loadTree();
      sMerk.focus();
    }
  });

  var loading = false;
  function loadTree() {
    if (tree || loading) return;
    loading = true;
    window.DFData.getVehicleTree().then(function (data) {
      tree = data;
      fill(sMerk, Object.keys(tree), sMerk.dataset.label);
      loading = false;
    }).catch(function (err) {
      loading = false;
      if (msg) msg.textContent = err.message;
    });
  }

  sMerk.addEventListener('change', function () {
    resetFrom(2);
    if (sMerk.value && tree[sMerk.value]) fill(sModel, Object.keys(tree[sMerk.value]), sModel.dataset.label);
  });
  sModel.addEventListener('change', function () {
    resetFrom(3);
    if (sModel.value) fill(sGen, Object.keys(tree[sMerk.value][sModel.value]), sGen.dataset.label);
  });
  sGen.addEventListener('change', function () {
    resetFrom(4);
    if (sGen.value) fill(sMot, tree[sMerk.value][sModel.value][sGen.value], sMot.dataset.label);
  });
  sMot.addEventListener('change', function () { go.disabled = !sMot.value; });

  go.addEventListener('click', function () {
    if (go.disabled) return;
    var params = new URLSearchParams({
      merk: sMerk.value,
      auto: sMerk.value + ' ' + sModel.value + ', ' + sGen.value + ', ' + sMot.value
    });
    location.href = go.dataset.target + '?' + params.toString();
  });
})();
